export const version = "address/5.0.5";
//# sourceMappingURL=_version.js.map